<!-- 机模配 -->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/number/change/record/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="yt.conditions.createUserName"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  (conditions = {
                    mouldId: $attrs.mouldEquipment.id,
                    pageSize: 10,
                    orderBy: 'createTime desc',
                  })
                )
              "
              >{{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fudailiao', scope.row, '50%')">
              {{ $t("fudailiao") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row);
                cycleConve();
              "
            >
              {{ $t("bianji") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/mouldEquipment/delete')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
      <template #shipeidunwei="scope">
        {{ scope.row.tonnageMin != null && scope.row.tonnageMax != null ? scope.row.tonnageMin + "-" + scope.row.tonnageMax : "" }}
      </template>
      <template #shipeijitai="scope">
        {{ scope.row.equipmentObjects | getEquipmentName }}
      </template>
      <template #biaozhunzhouqimiaomo="scope">
        {{ scope.row.cycle / 1000 }}
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  components: {},
  name: "web_mould_number_change_record",
  data() {
    return {
      columns: [
        {
          label: "shengchangongdanhao",
          prop: "no",
          width: 130,
        },
        {
          label: "ERPgongdanhao",
          prop: "erpNo",
          width: 130,
        },
        {
          label: "shebeimingcheng",
          prop: "equipmentName",
        },
        {
          label: "mujubianhao",
          prop: "mouldCode",
        },
        {
          label: "mujumingcheng",
          prop: "mouldName",
        },
        {
          label: "chanpinbianma",
          prop: "materialCode",
        },
        {
          label: "chanpinmingcheng",
          prop: "materialName",
        },
        {
          label: "xiugaiqianmoqiangshu",
          prop: "mouldNumBefore",
        },
        {
          label: "xiugaihoumoqiangshu",
          prop: "mouldNumAfter",
        },
        {
          label: "caozuoren",
          prop: "createUserName",
        },
        {
          label: "caozuoshijian",
          prop: "createTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        mouldId: this.$attrs.mouldEquipment.id,
        pageSize: 10,
        orderBy: "createTime desc",
      };
      this.yt.get(1);
    }, 300);
  },
  filters: {
    getEquipmentName(value) {
      return value
        .map((item) => {
          return item.name;
        })
        .join(",");
    },
  },
  methods: {
    setDefaultValue(action) {
      this.yt.editObj.cavity = 1;
      this.yt.editObj.cycle = 1;
      this.yt.editObj.enabled = true;
    },
    cycleConve() {
      this.yt.editObj.cycle = (this.yt.editObj.cycle / 1000).toFixed(1);
    },
    beforeAdd(params, url) {
      params.cycle = params.cycle * 1000;
      console.log("tonnageMin", params.tonnageMin);
      console.log("tonnageMax", params.tonnageMax);
      if (params.tonnageMin != undefined) {
        //如果输入了最小吨位数,没输入最大吨位数,提示用户输入最大吨位数
        if (params.tonnageMax == undefined) {
          // 请输入最大吨位数
          this.utils.errorMessage(this.$t("qingshuruzuidadunweishu"));
          return;
        }
      }
      if (params.tonnageMax != undefined) {
        //如果输入了最大吨位数,没输入最小吨位数,提示用户输入最小吨位数
        if (params.tonnageMin == undefined) {
          // 请输入最大吨位数
          this.utils.errorMessage(this.$t("qingshuruzuixiaodunweishu"));
          return;
        }
      }
      if (params.tonnageMin > params.tonnageMax) {
        this.utils.errorMessage(this.$t("tonnageError"));
        return;
      }
      params.mouldId = this.$attrs.mouldEquipment.id;
      if (params.equipmentId != undefined && params.equipmentId != null) {
        params.equipmentId = params.equipmentId.toString();
      }
      return params;
    },
  },
};
</script>

<style scoped lang="scss">
.shift {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
